/*
 *  Site specific controller for using the Impromptu module
 *  http://trentrichardson.com/Impromptu/
 */
$(function () {
  Renoworks = window.Renoworks || {};
  Renoworks.Prompt = new Prompt();

  var TURNED_ON = true;
  var CURRENT = 'startHelp';

  var tourSubmitFunc = function(evnt, value, message, formVals) {
    if (value === -1) {
      $.prompt.prevState();
      return false;
    } else if (value === 1) {
      $.prompt.nextState();
      return false;
    }
  }

  var answerFunc = function answerFunc(evnt, value, message, formVals) {
    TURNED_ON = value;
    if (TURNED_ON) {
      Renoworks.Prompt.startHelp();
    } else {
      $('.help_toggle span').html('Off');
    }
  }

  var askTourStates = [
    {
      title: 'Help Notifications?',
      html: 'Would you like to turn on Help Notifications for step-by-step instructions for using our visualizer?',
      buttons: {
        Yes: true,
        No: false
      },
      focus: 0,
      position: {
        container: 'nav',
        x: 100,
        y: 100,
        width: 250,
        arrow: 'tr'
      },
      submit: answerFunc
    }
  ];

  var startTourStates = [
    {
      title: 'Get Started',
      html: 'Welcome to the ProDoor Visualizer. Choose a sample scene, or upload your own to begin designing.',
      buttons: {
        Close: 0,
        Next: 1
      },
      focus: 1,
      position: {
        container: '.buttons',
        x: -280,
        y: 0,
        width: 250,
        arrow: 'rb'
      },
      submit: tourSubmitFunc
    },
    {
      title: 'Account',
      html: 'Create an account to save your work or sign in to view your previously saved projects.',
      buttons: {
        Ok: 0
      },
      focus: 0,
      position: {
        container: 'nav',
        x: 0,
        y: 120,
        width: 250,
        arrow: 'tr'
      },
      submit: tourSubmitFunc
    }
  ];

  var productTourStates = [
    {
      title: 'Choose Options',
      html: 'Choose from the options available to visualize your new garage door. More options will become available as you make selections.',
      buttons: {
        Close: 0,
        Next: 1
      },
      focus: 1,
      position: {
        container: '.product_collections',
        x: 420,
        y: 0,
        width: 300,
        arrow: 'lt'
      },
      submit: tourSubmitFunc
    },
    {
      title: 'Choose Collection',
      html: 'Choose from short, long and carriage panels to help you visualize your new garage door. More collections will become available as you make selections.',
      buttons: {
        Close: 0,
        Next: 1
      },
      focus: 1,
      position: {
        container: '.button_modal[data-label="prepare"]',
        x: -100,
        y: 60,
        width: 300,
        arrow: 'tr'
      },
      submit: tourSubmitFunc
    },
    {
      title: 'Review',
      html: 'Visit the review tab to get an overview of your project. You can also print, and share your project from there!',
      buttons: {
        Ok: 0
      },
      focus: 0,
      position: {
        container: '.button_modal[data-label="review_doors"]',
        x: -220,
        y: 60,
        width: 300,
        arrow: 'tr'
      },
      submit: tourSubmitFunc
    }
  ];

  var reviewTourStates = [
    {
      title: 'Save',
      html: 'Save your design here in order to retrieve it at a later time. You will need to create an account to do so if you don\'t already have one.',
      buttons: {
        Close: 0,
        Next: 1
      },
      focus: 1,
      position: {
        container: '.button[data-label="show_save_design"]',
        x: 0,
        y: -180,
        width: 300,
        arrow: 'bl'
      },
      submit: tourSubmitFunc
    },
    {
      title: 'Print',
      html: 'Print or save a design report with a summary of the garage door selections you have made on your home.',
      buttons: {
        Close: 0,
        Next: 1
      },
      focus: 1,
      position: {
        container: '.button[data-label="print"]',
        x: 0,
        y: -180,
        width: 300,
        arrow: 'bl'
      },
      submit: tourSubmitFunc
    },
    {
      title: 'Share',
      html: 'Easily share your project with friends and family.',
      buttons: {
        Ok: 0
      },
      focus: 0,
      position: {
        container: '.share[data-locale-title="share_title"]',
        x: 0,
        y: -180,
        width: 300,
        arrow: 'bl'
      },
      submit: tourSubmitFunc
    }
  ];

  var startTour = {
    selector: '.projects_button, .upload_button',
    state: startTourStates,
    type: 'startHelp',
  };

  var productTour = {
    selector: '#select_product.page.full_height, #sub_header_menu',
    state: productTourStates,
    type: 'startProductHelp',
  };

  var reviewTour = {
    selector: '.action_buttons',
    state: reviewTourStates,
    type: 'startReviewHelp',
  };

  function canShowPrompt(selector) {
    var canShow = true;
    $(selector).each(function () {
      canShow = canShow && $(this).is(':visible');
    });

    return canShow;
  }

  function showPrompt(tour) {
    if (TURNED_ON && canShowPrompt(tour.selector)) {
      $.prompt(tour.state);
    }

    CURRENT = tour.type;
  }

  function Prompt() {

  }

  Prompt.prototype.toggleHelp = function () {
    if (TURNED_ON) {
      TURNED_ON = false;
    } else {
      TURNED_ON = true;
      this[CURRENT]();
    }
  }

  Prompt.prototype.getState = function () {
    return TURNED_ON;
  }

  Prompt.prototype.askHelp = function () {
    if(canShowPrompt('.help_toggle')) {
      $.prompt(askTourStates);
    }
  }

  Prompt.prototype.startHelp = function () {
    showPrompt(startTour);
  }

  Prompt.prototype.startProductHelp = function () {
    showPrompt(productTour);
  }

  Prompt.prototype.startReviewHelp = function () {
    showPrompt(reviewTour);
  }

});
